export const areAllIdsInT2 = (t1, t2) => {
	const t2Ids = new Set(t2.map((item) => item.uuid));

	return t1.every((id) => t2Ids.has(id));
};
export const getIsMandatoryField = (sections) => {
	const requiredField = [];
	// eslint-disable-next-line array-callback-return
	sections?.map((section) => {
		// eslint-disable-next-line array-callback-return
		section?.layout?.map((layout) => {
			if (layout.options.isMandatory && !layout.hidden) {
				requiredField.push(layout.id);
			}
		});

		// eslint-disable-next-line array-callback-return
		section?.subsection?.map((subsection) => {
			// eslint-disable-next-line array-callback-return
			subsection?.layout?.map((layout) => {
				if (layout.options.isMandatory && !layout.hidden) {
					requiredField.push(layout.id);
				}
			});
		});
	});
	return requiredField;
};
